/* Newsletter popup.
 *
 * Appears after a RANDOM delay, and if dismissed may return up to max-shows
 * times in a session with a longer random gap each time, so it never arrives
 * on a beat the visitor can predict.
 *
 * State is split on purpose:
 *   localStorage  subscribed (forever) and dismissedUntil (the snooze) —
 *                 these must survive a reload and a return visit.
 *   sessionStorage  how many times it has already shown this visit.
 *
 * Timers are setTimeout, never rAF: rAF is throttled to nothing in a
 * background tab, so a visitor who opens the site in a tab and comes back to
 * it would never see the popup at all.
 */
(function () {
  'use strict';

  var KEY_SUB = 'drmedyx:nl:subscribed';
  var KEY_SNOOZE = 'drmedyx:nl:snoozeUntil';
  var KEY_SHOWN = 'drmedyx:nl:shown';

  function ls(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); }
    catch (e) { return null; }              // private mode: fail open, never throw
  }
  function ss(get, key, val) {
    try { return get ? sessionStorage.getItem(key) : sessionStorage.setItem(key, val); }
    catch (e) { return null; }
  }

  function rand(min, max) { return (min + Math.random() * Math.max(0, max - min)) * 1000; }

  function init(root) {
    if (root.dataset.nlpReady) return;
    root.dataset.nlpReady = '1';

    var panel = root.querySelector('.nlp__panel');
    var d = root.dataset;
    var maxShows = parseInt(d.maxShows, 10) || 1;
    var snoozeDays = parseInt(d.snoozeDays, 10) || 7;

    /* Never interrupt a purchase. */
    if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;

    /* QA escape hatch. The first show fires on a random 12-30s timer, which
     * lands squarely inside ops/shoot-widths.mjs's virtual-time budget — every
     * screenshot is a coin flip on whether it photographs the page or the
     * popup, and it cost two wrong hero shots on 9 Aug. A real visitor never
     * has this parameter, so nothing about production behaviour changes. */
    if (/[?&]nopopup\b/.test(location.search)) return;

    /* Subscribing ends it permanently. A form that posted successfully means
     * this visitor is on the list — Shopify reloads the page with the flag. */
    if (root.querySelector('[data-nlp-success]')) { ls(false, KEY_SUB, '1'); return; }
    if (ls(true, KEY_SUB)) return;

    var until = parseInt(ls(true, KEY_SNOOZE), 10);
    if (until && Date.now() < until) return;

    var shown = parseInt(ss(true, KEY_SHOWN), 10) || 0;
    if (shown >= maxShows) return;

    var lastFocus = null;
    var timer = null;

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }

    function onKey(e) {
      if (e.key === 'Escape') { close('dismiss'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      /* Forced reflow, NOT requestAnimationFrame. The transition needs a start
       * state to move from, and reading offsetWidth commits one synchronously.
       * rAF would not: it is throttled to nothing in a background tab, and a
       * starved frame leaves the panel un-hidden but at opacity 0 — an
       * invisible backdrop swallowing every click on the page. */
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var f = focusables();
      if (f.length) f[0].focus();

      shown += 1;
      ss(false, KEY_SHOWN, String(shown));
    }

    function close(reason) {
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();

      if (reason === 'dismiss') {
        /* Out of appearances for this visit: snooze across visits so a
         * returning reader is not hit again tomorrow. */
        if (shown >= maxShows) {
          ls(false, KEY_SNOOZE, String(Date.now() + snoozeDays * 864e5));
        } else {
          schedule(+d.repeatMin || 90, +d.repeatMax || 180);
        }
      }
    }

    function schedule(min, max) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (document.hidden) {           // do not burn an appearance on a tab
          schedule(15, 30);              // nobody is looking at
          return;
        }
        open();
      }, rand(min, max));
    }

    root.querySelectorAll('[data-nlp-close]').forEach(function (el) {
      el.addEventListener('click', function () { close('dismiss'); });
    });

    schedule(+d.minDelay || 12, +d.maxDelay || 30);
  }

  function boot() { document.querySelectorAll('[data-nlp]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
